import { useTranslation } from 'react-i18next';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';

interface UseOptionsErrorsProps {
    hasBeenSubmitted: boolean;
    optionFieldsLength: number;
    optionsError:
        | Merge<
              FieldError,
              (
                  | Merge<
                        FieldError,
                        FieldErrorsImpl<{
                            id: string;
                            value: string;
                            isCorrectAnswer?: boolean;
                        }>
                    >
                  | undefined
              )[]
          >
        | undefined;
}

export const useOptionsErrors = ({
    hasBeenSubmitted,
    optionFieldsLength,
    optionsError,
}: UseOptionsErrorsProps) => {
    const { t } = useTranslation();

    const rootOptionsMessage =
        optionsError &&
        typeof optionsError === 'object' &&
        'message' in optionsError &&
        optionsError.message
            ? String(optionsError.message)
            : null;

    // Empty-options error, or dealbreaker "pick a correct answer" root message
    const shouldShowOptionsError =
        hasBeenSubmitted &&
        optionsError !== undefined &&
        optionsError !== null &&
        (optionFieldsLength === 0 || !!rootOptionsMessage);

    const noOptionsErrorMessage = shouldShowOptionsError
        ? rootOptionsMessage ||
          (typeof optionsError === 'string'
              ? optionsError
              : t('saveJob.optionsRequired'))
        : null;

    return {
        hasNoOptionsError: shouldShowOptionsError,
        noOptionsErrorMessage,
    };
};
